import { motion } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";

const SERVICES = [
  {
    id: "marketing",
    icon: "/assets/icon_marketing.svg",
    title: ["Marketing &", "Advertising"],
    text: "Targeted strategies to build your brand, attract customers, and drive real results.",
  },
  {
    id: "website",
    icon: "/assets/icon_website.svg",
    title: ["Website", "Development"],
    text: "Modern, responsive websites designed to showcase your business and convert visitors into customers.",
  },
  {
    id: "app",
    icon: "/assets/icon_app.svg",
    title: ["Mobile App", "Development"],
    text: "Custom mobile applications built to solve real problems, create new opportunities, and scale your business.",
  },
];

export const Services = () => (
  <section id="services" className="services" data-testid="services-section">
    <div className="shell">
      <Reveal className="section-head">
        <span className="head-rule" aria-hidden="true" />
        <h2 className="section-title">OUR SERVICES</h2>
        <span className="head-rule" aria-hidden="true" />
      </Reveal>
      <div className="cards">
        {SERVICES.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.12} className="card-reveal">
            <motion.article
              className="service-card"
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 260, damping: 22 }}
              data-testid={`service-card-${s.id}`}
            >
              <img src={s.icon} alt="" className="service-icon" width="72" height="72" />
              <h3>
                {s.title[0]}
                <br />
                {s.title[1]}
              </h3>
              <p>{s.text}</p>
            </motion.article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
